import * as v from 'valibot'
import router from '@app/router'

export function isRealtimeEnabled() {
	const parse_res = v.safeParse(
		v.object({
			is_rt: v.optional(v.union([v.pipe(v.number(), v.toBoolean()), v.pipe(v.string(), v.parseBoolean())]), 0),
		}),
		router.currentRoute()?.query,
	)

	if (!parse_res.success) {
		return false
	}

	return parse_res.output.is_rt
}
